module.exports = __webpack_public_path__ + "static/img/null-fz.d6f3da12.png";